module.exports = __webpack_public_path__ + "static/media/otherIcons.6bae09ae.png";